<template>
  <div class="pa-3">
    <div class="d-flex align-center flex-wrap">
      <v-switch color="secondary" :disabled="busy" hide-details label="Accepting feedback" :loading="busy" :input-value="accepting" @change="change(Boolean($event))" />
      <span v-if="accepting && expiresAt" class="ml-3 text-caption">Valid until {{ new Date(expiresAt).toLocaleString() }}</span>
    </div>
    <v-alert v-if="error" type="error">{{ error }}</v-alert>
    <v-alert v-if="message" type="success">{{ message }}</v-alert>
    <v-btn v-if="link" color="secondary" :disabled="busy" @click="copy">Copy link</v-btn>
    <v-text-field v-if="link" label="Feedback link" :value="link" readonly @focus="$event.target.select()" />
  </div>
</template>
<script>
import campaignAPIs from './campaignAPIs'
export default {
  props: { campaignId: { type: String, required: true } },
  data: () => ({ accepting: false, expiresAt: null, busy: false, link: '', error: '', message: '' }),
  watch: {
    campaignId: {
      immediate: true,
      async handler(id) {
        this.busy = true
        this.link = ''
        this.accepting = false
        this.expiresAt = null
        this.error = ''
        this.message = ''
        try {
          const state = await campaignAPIs.getFeedbackAccess(id)
          if (id !== this.campaignId) return
          this.accepting = state.accepting
          this.expiresAt = state.expiresAt
          this.link = state.token ? `${window.location.origin}/client/feedback-form/${id}#token=${encodeURIComponent(state.token)}` : ''
        } catch (error) {
          this.error = 'Unable to load feedback settings.'
        } finally {
          this.busy = false
        }
      }
    }
  },
  methods: {
    async copy() {
      this.error = ''
      this.message = ''
      try {
        await navigator.clipboard.writeText(this.link)
        this.message = 'Feedback link copied.'
      } catch (error) {
        this.error = 'Unable to copy link.'
      }
    },
    async change(accepting) {
      this.busy = true
      this.error = ''
      this.message = ''
      try {
        const state = await campaignAPIs.changeFeedbackAccess(this.campaignId, accepting)
        this.accepting = state.accepting
        this.expiresAt = state.expiresAt
        this.link = state.token ? `${window.location.origin}/client/feedback-form/${this.campaignId}#token=${encodeURIComponent(state.token)}` : ''
        if (accepting && this.link) {
          try {
            await navigator.clipboard.writeText(this.link)
            this.message = 'Feedback link copied.'
          } catch (error) {
            this.error = 'Unable to copy link.'
          }
        } else {
          this.message = 'Feedback closed.'
        }
      } catch (error) {
        this.error = 'Unable to change feedback settings.'
      } finally {
        this.busy = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// FeedbackAccessPanel.vue?481a4e37